import { pendingBookingConstants } from '../utils/types';

export default function pendingBooking(state = {}, action) {
  switch (action.type) {
  case pendingBookingConstants.SET_PENDING_SESSION_EVENT_ID:
    return { ...state, sessionEventId: action.payload.sessionEventId };
  case pendingBookingConstants.SET_PENDING_COURT_EVENT_ID:
    return { ...state, courtEventId: action.payload.courtEventId };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pendingBookingReducer.js